import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import type { AppNavigationProp } from '../navigation/types';

/**
 * Hook for sidebar navigation integration with React Navigation
 */
export function useSidebarNavigation() {
  const navigation = useNavigation<AppNavigationProp>();

  const navigateToRoute = useCallback(
    (route: string) => {
      // Since we're using a drawer navigator directly, navigate within it
      (navigation as any).navigate?.(route);
    },
    [navigation]
  );

  return {
    navigateToRoute,
  };
}
